import { ReturnStatement } from "@angular/compiler";
import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SelectionType } from "@swimlane/ngx-datatable";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteFilter } from "src/app/models/Dte/DteFilter";
import { IDte } from "src/app/models/Dte/IDte";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { Sucursal } from "src/app/models/Sucursal";
import { TipoDocumentoReferencia } from "src/app/models/TipoDocRef";
import { TipoDte } from "src/app/models/tipoDte";
import { DteEmitidosService } from "src/app/services/dte-emitidos.service";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { PagedResponse } from "src/app/shared/models/PagedResponse";
import Swal from "sweetalert2";
import { ConfigDocumentosDetalle } from "./config-documentos-detalle";

@Component({
	selector: "app-cuadro-documento-detalle",
	templateUrl: "./cuadro-documento-detalle.component.html",
	styleUrls: ["./cuadro-documento-detalle.component.scss"],
})
export class CuadroDocumentoDetalleComponent implements OnInit {
	public loading: boolean = false;
	public searchCatalog: TipoDocumentoReferencia[] = [];
	public searchLoading: boolean = false;
	public detalleDocumentoFormGroup: FormGroup;
	public filter = new DteFilter();
	public consultandoDocumento: boolean = false;
	public documentRows: DteEmitido[] = [];
	public pageDocuments = new Page();
	public SelectionType = SelectionType;
	private documentListModalRef: any;
	public configLocal = ConfigDocumentosDetalle;
	private currentEmisorId = this.tokenService.getCompany();
	private currentEmisor: Emisor = (JSON.parse(this.localStorage.getEmisores()) as Emisor[]).find((em) => em.emisorId == this.currentEmisorId);
	public tipoDteSource: TipoDte[];
	public selectedDocuments: DteEmitido[] = [];
	public selectedAllItemsInPage: any = {}; // bool para la seleccion total de elementos en tabla
	public currentDetalle: DetalleDte;
	constructor(private formBuilder: FormBuilder, private modalService: NgbModal, private dteService: DteEmitidosService, private facturador: FacturacionIndividualService, private utilities: UtilitiesService, private tokenService: TokenStorageService, private ref: ChangeDetectorRef, private localStorage: LocalStorageService) {}

	ngOnInit(): void {
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
		this.createDocumentForm();
		this.filter.emisorId = this.currentEmisorId;
		this.filter.sucursalId = this.tokenService.getSubsidiary();
		this.filter.ambienteId = this.currentEmisor.ambiente;
		this.filter.tipoDteId = "";
	}

	createDetalleDteFromForm(): DetalleDte {
        let detalle = new DetalleDte();
        detalle.nombre = this.detalleDocumentoFormGroup.value.nombreItem;
        detalle.descripcion = this.detalleDocumentoFormGroup.value.descripcion;
        detalle.cantidad = this.detalleDocumentoFormGroup.value.cantidad;
        detalle.codigoInterno = this.detalleDocumentoFormGroup.value.codigo;
        detalle.total = this.detalleDocumentoFormGroup.value.total;
        detalle.descuento = this.detalleDocumentoFormGroup.value.descuento;
        detalle.recargo = this.detalleDocumentoFormGroup.value.recargo;
        detalle.esExento = this.detalleDocumentoFormGroup.value.exento;
		detalle.precioUnitario = detalle.total
        return detalle;
    }
    agregarManual() {
        if (this.detalleDocumentoFormGroup.valid) {
            this.currentDetalle = this.createDetalleDteFromForm();
        }
        this.onSubmit();
    }


	openDocumentsListModal(modalRef) {
		if (this.facturador.selectedClient == undefined) {
			Swal.fire({
				icon: "error",
				title: "Sin Cliente",
				text: "No ha seleccionado un cliente para la consulta de documentos. Intente nuevamente.",
			});
			return;
		}
		this.filter.receptorId = this.facturador.selectedClient.receptorId;
		this.setPageDocuments({ offset: 0 });
		this.selectedDocuments = [];
		this.documentListModalRef = this.modalService.open(modalRef, {
			windowClass: "",
			size: "xl",
		});
	}

	onSubmit() {
		if (this.detalleDocumentoFormGroup.valid) {
			this.facturador.addDetailDocumentSubject.next(this.currentDetalle);
			this.detalleDocumentoFormGroup.reset();
			this.currentDetalle = new DetalleDte();
		}
	}

	setPageDocuments(pageInfo) {
		this.loading = true;
		this.consultandoDocumento = true;
		this.pageDocuments.pageNumber = pageInfo.offset;
		let localPage = { ...this.pageDocuments };
		localPage.pageNumber += 1;
		this.dteService.documentsOfClient(this.filter, localPage).subscribe(
			(result) => {
				let elements = result.data as DteEmitido[];
				this.ref.detectChanges();
				elements.forEach((row) => {
					this.setTipoDteToElement(row);
					row.nombreSucursal = this.setNombreSucursal(row.sucursalId);
				});
				this.setPagefromResponse(this.pageDocuments, result);

				this.documentRows = [...elements];
				this.loading = false;
				this.consultandoDocumento = false;
				this.ref.detectChanges();
			},
			(error) => {
				this.loading = false;
				this.consultandoDocumento = false;
				this.ref.detectChanges();

				Swal.fire({
					icon: "error",
					title: "Error en documentos",
					text: "No fue posible traer la lista de documentos para liquidación. " + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}

	createDetalleDte(dteArray: DteEmitido[]): DetalleDte {
		let newDetail: DetalleDte = new DetalleDte();
		newDetail.relatedDocumentsIds = dteArray.map((d) => d.dteId);
		newDetail.codigoInterno = dteArray[0].codigoTipoDte.toString();
		newDetail.cantidad = 1;
		newDetail.total = dteArray.reduce((sum, current) => (sum += current.total), 0);
		newDetail.descripcion = dteArray.reduce((folioStrings, current) => (folioStrings += current.folio + ", "), "");
		newDetail.descripcion = "Folio: " + newDetail.descripcion.slice(0, newDetail.descripcion.length - 2);
		newDetail.nombre = dteArray[0].nombreTipoDte;
		newDetail.precioUnitario = newDetail.total;
		newDetail.esExento = newDetail.codigoInterno == "34" || newDetail.codigoInterno == "41";
		return newDetail;
	}

	selectedDocumentToForm(detalle: DetalleDte) {
		this.detalleDocumentoFormGroup.controls.nombreItem.patchValue(detalle.nombre);
		this.detalleDocumentoFormGroup.controls.descripcion.patchValue(detalle.descripcion), this.detalleDocumentoFormGroup.controls.cantidad.patchValue(detalle.cantidad);
		this.detalleDocumentoFormGroup.controls.codigo.patchValue(detalle.codigoInterno);
		this.detalleDocumentoFormGroup.controls.total.patchValue(detalle.total);
		this.detalleDocumentoFormGroup.controls.descuento.patchValue(detalle.descuento);
		this.detalleDocumentoFormGroup.controls.recargo.patchValue(detalle.recargo);
		this.detalleDocumentoFormGroup.controls.exento.patchValue(detalle.esExento);

	}

	searchElementsByFilter(event) {
		this.filter = this.filterConcordance(this.configLocal.barraBusqueda.criteriosKeys, this.filter, event);
		this.filter.tipoDteId = event.tipoDteId != null ? event.tipoDteId : "";
		this.filter.fechaDesde = event.fechaInicio;
		this.filter.fechaHasta = event.fechaFin;
		this.filter.importado = event.importado ? true : false;
		this.filter[event.criterio] = event.busqueda;
		this.filter.estadoSii = event.estadoDte;
		this.setPageDocuments({ offset: 0 });
	}

	filterConcordance(configCriterias, dteFilter: DteFilter, eventFilter): DteFilter {
		//vaciar del dteFilter aquellos campos distinto al presnetado en el eventFilter actual, segun el arreglo configCriterias
		configCriterias.forEach((criteria) => {
			if (criteria != eventFilter.criterio) {
				dteFilter[criteria] = "";
			}
		});
		return dteFilter;
	}

	createDocumentForm() {
		this.detalleDocumentoFormGroup = this.formBuilder.group({
			codigo: [, Validators.required],
			nombreItem: [, Validators.required],
			cantidad: [, Validators.required],
			total: [, Validators.required],
			descripcion: [],
			descuento: [],
			recargo: [],
			exento: [false],
		});
	}

	setTipoDteToElement(row: IDte) {
		if (row.tipoDteId) {
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.tipoDteId == row.tipoDteId);
			row.nombreTipoDte = tipoDteAsociado.nombre;
		}
	}

	setNombreSucursal(sucursalId: string): string {
		let lista = JSON.parse(this.localStorage.getSucursales()) as Sucursal[];
		let sucursalEncontrada = lista.find((suc) => suc.sucursalId === sucursalId);
		if (!sucursalEncontrada) {
		  return "Sucursal no encontrada";
		}
	  
		return sucursalEncontrada.nombre;
	  }
	  

	setPagefromResponse(currentPage: Page, data: PagedResponse<DteEmitido>) {
		currentPage.pageSize = data.pageSize;
		currentPage.pageNumber = data.pageNumber - 1 < 0 ? 0 : data.pageNumber - 1;
		currentPage.totalPages = data.totalPages;
		currentPage.totalElements = data.totalRecords;
	}
	onSelect({ selected }) {
		this.selectedDocuments.splice(0, this.selectedDocuments.length);
		this.selectedDocuments.push(...selected);
	}

	selectAll(event) {
		if (!this.selectedAllItemsInPage[0]) {
			if (this.selectedDocuments.length > 0) {
				this.documentRows.map((dte) => {
					this.selectedDocuments = this.selectedDocuments.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
				});
			}
			this.selectedDocuments.push(...this.documentRows);
			this.selectedDocuments = [...this.selectedDocuments];
			this.selectedAllItemsInPage[0] = true;
		} else {
			this.documentRows.map((dte) => {
				this.selectedDocuments = this.selectedDocuments.filter((selectedDte) => selectedDte.dteId !== dte.dteId);
			});
			this.selectedAllItemsInPage[0] = false;
		}
	}

	procesarDocumentsADetalles() {
		//check for same dte type
		if (this.selectedDocuments.length == 0) return;
		if (!this.selectedDocuments.every((dte) => dte.tipoDteId == this.selectedDocuments[0].tipoDteId)) {
			Swal.fire({
				icon: "error",
				title: "Documentos de distinto tipo",
				text: "Ha seleccionado documentos de distintos tipos para generar un elemento de detalle en la Liquidación. Seleccione solo documentos de un tipo por cada línea de detalle.",
			});
			return;
		}
		//transform to DetalleDte
		let detalle = this.createDetalleDte(this.selectedDocuments);
		this.currentDetalle = detalle;
		this.selectedDocumentToForm(detalle);
		this.documentListModalRef.close();
	}
}
